import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dmmp-banner-slide',
  templateUrl: './banner-slide.component.html'
})
export class BannerSlideComponent implements OnInit {

  @Input() content
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
